"use strict";import{Coachmark as a}from"./src/Coachmark.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-coachmark",a);
//# sourceMappingURL=sp-coachmark.js.map
